module.exports = __webpack_public_path__ + "img/37_145.ab69ca15.png";